module.exports = __webpack_public_path__ + "static/media/logo03.3723174c.png";